<template>
  <li
    :class="{
      'flex flex-col overflow-hidden rounded-t border border-www-color-neutral-very-light bg-www-color-white': true,
    }"
  >
    <PTCLink
      v-if="heroImage?.asset"
      :to="destinationRoute"
      :class="{
        'h-40 overflow-hidden': true,
      }"
    >
      <PtcPicture
        v-if="heroImage?.asset"
        :class="{ 'block h-full w-full': true }"
        :img-attrs="{
          class: { 'min-h-full min-w-full block object-cover object-center': true },
        }"
        :modifiers="{
          w: 300,
        }"
        :quality="75"
        provider="sanity"
        :src="heroImage.asset._ref"
        :alt="resolvedImage?.altText || ''"
        loading="lazy"
      />
    </PTCLink>

    <div
      :class="{
        'flex flex-1 flex-col px-[34px] pb-3 pt-22px': true,
      }"
    >
      <PTCLink
        :to="destinationRoute"
        :class="{
          'font-black text-www-color-neutral-medium-dark decoration-www-color-primary hover:underline': true,
        }"
      >
        {{ title }}
      </PTCLink>

      <span
        :class="{
          'mt-1 text-10px font-medium text-www-color-neutral-medium-dark': true,
        }"
      >
        {{ formatDateUTC(articleDate, 'MM.DD.YYYY') }}
      </span>
    </div>

    <div class="px-[34px]">
      <PTCLink
        :to="destinationRoute"
        :class="{ 'group/more flex items-center gap-10px self-start': true }"
      >
        <span
          :class="{
            'font-ptc-Rajdhani font-bold uppercase leading-none text-www-color-primary-lighter group-hover/more:underline': true,
          }"
        >
          learn more
        </span>

        <PtcIcon
          name="ptc-arrow-white"
          :class="{
            'text-base font-black text-www-color-primary-lighter group-hover/more:text-www-color-primary-lighter': true,
          }"
        />
      </PTCLink>
    </div>

    <div class="mt-10 h-1.5 w-full bg-www-color-primary-lighter"></div>
  </li>
</template>

<script lang="ts" setup>
import PTCLink from '~/components/Atoms/PTCLink/PTCLink.vue';
import PtcPicture from '~/components/Atoms/PtcPicture/PtcPicture.vue';
import PtcIcon from '~/components/Atoms/PtcIcon/PtcIcon.vue';
import type { WhatsNewQueryResult } from '~/sanity/types';

type Props = WhatsNewQueryResult[number];

const props = defineProps<Props>();
const { getResolvedImage } = useRefsStore();
const resolvedImage = await getResolvedImage(props.heroImage?.asset?._ref);

const destinationRoute = props.currentPathname ?? '#';
</script>
